export const source = 'srp';

export enum SearchDispatcherEvent {
  AppliedFilters = 'applied_filters',
  DismissPriceDrop = 'dismiss_price_drop',
  NewInventory = 'new_inventory',
  SaveSearch = 'save_search'
}
